import { Route, Switch, useRouteMatch } from "react-router-dom";
import React from "react";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import PublisherUpdatesEdit from "./PublisherUpdatesEdit";
import PublisherUpdatesList from "./PublisherUpdatesList";
function PublisherUpdates() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, component: PublisherUpdatesList }),
        React.createElement(Route, { path: "".concat(cleanPath, "/approval/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherUpdatesEdit, null))); } })));
}
export default PublisherUpdates;
